import { useMemo } from 'react';
import { Platform, StyleSheet, Dimensions } from 'react-native';
import theme from '../../common/theme';
import { useScale } from '../../hooks/useScale';
import { useColors } from '../../hooks/useColors';

const { height } = Dimensions.get('window');

const isWeb = Platform.OS === 'web';
const isAndroid = Platform.OS === 'android';

const SelectStyles = () => {
  const { scale } = useScale();
  const { colors } = useColors();

  return useMemo(
    () =>
      StyleSheet.create({
        inputContainer: {
          height: scale(44),
          maxHeight: scale(44),
          borderRadius: 6,
          overflow: 'hidden',
          paddingRight: 12,
          backgroundColor: theme.colors.transparent,
          zIndex: 2,
          flexDirection: 'row',
          alignItems: 'center',
        },
        inputTitleText: {
          fontSize: scale(14),
          lineHeight: scale(14),
          marginBottom: 6,
          paddingLeft: 12,
          color: theme.colors.grey6,
        },
        accessory: {
          position: 'absolute',
          right: 1,
          bottom: 1,
          width: scale(42),
          height: scale(42),
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
          backgroundColor: theme.colors.transparent,
        },
        bgStyle: {
          width: '100%',
          position: 'absolute',
          height: height,
        },
        optionsContainer: {
          width: scale(260),
          backgroundColor: theme.colors.white,
          borderRadius: theme.radius.s,
        },
        optionsPopup: {
          maxHeight: isAndroid ? undefined : scale(300),
          paddingVertical: 10,
          borderWidth: isWeb ? 0 : 2,
          borderColor: theme.colors.grey3,
          borderRadius: theme.radius.m,
          backgroundColor: theme.colors.white,
          ...theme.shadow.light,
        },
        option: {
          paddingVertical: 12,
          paddingHorizontal: 20,
          flexDirection: 'row',
          alignItems: 'center',
        },
        colourValue: {
          marginRight: 8,
          flexDirection: 'row',
          alignItems: 'center',
          paddingLeft: 12,
        },
        colourContainer: {
          width: 22,
          height: 22,
          marginRight: 8,
          borderRadius: 28,
        },
        selectedOptionText: {
          color: colors.text,
        },
      }),
    [colors, scale],
  );
};

export default SelectStyles;
